import { Inject, Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class DatePickerService {

  constructor(
    @Inject('DATE_PICKER_SHOW_LABEL') private showLabel: boolean = true,
    @Inject('DATE_PICKER_AUTOCOMPLETE') private autocomplete: string = "off",
    @Inject('DATE_PICKER_NO_AUTO_COMPLETE_NULL') private noAutoCompleteNull: boolean = true,
    @Inject('DATE_PICKER_FOCUS_INITIAL') private focusInitial: boolean = false,
    @Inject('DATE_PICKER_VALIDATOR_MESSAGE') private validatorMessage: boolean = false,
    @Inject('DATE_PICKER_TOOLTIP_MESSAGE') private tooltipMessage: boolean = true,
    @Inject('DATE_PICKER_SUBMITTED') private submitted: boolean = true,
    @Inject('DATE_PICKER_VALIDATOR_ALERT') private validatorAlert: boolean = false
  ) {
  }

  public getShowLabel(): boolean {
    return this.showLabel;
  }
  public getAutocomplete(): string {
    return this.autocomplete;
  }
  public getNoAutoCompleteNull(): boolean {
    return this.noAutoCompleteNull;
  }
  public getFocusInitial(): boolean {
    return this.focusInitial;
  }
  public getValidatorMessage(): boolean {
    return this.validatorMessage;
  }
  public getTooltipMessage(): boolean {
    return this.tooltipMessage;
  }
  public getSubmitted(): boolean {
    return this.submitted;
  }
  public getValidatorAlert(): boolean {
    return this.validatorAlert;
  }
  
  
}